import './index.scss';

import React from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useActions from '../../hooks/useActions';

const Header = () => {
  const history = useHistory();
  const { header, subHeader } = useSelector((state) => state.appInfo);
  const { user } = useSelector((state) => state.auth);
  const { signOut } = useActions();
  const {
    length,
    location: { pathname }
  } = history;

  return (
    <div className="app_header d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        {length >= 1 && pathname.split('/').filter((str) => str !== '').length >= 2 && (
          <button onClick={() => history.goBack()} type="button" className="btn app_header_link">
            <span className="app_header_arrow">
              <HiArrowNarrowLeft />
            </span>
          </button>
        )}
        <div className="app_header_title">
          {header || 'Placeholder'} {subHeader ? ` / ${subHeader}` : null}
        </div>
      </div>
      <NavDropdown
        title={user ? `${user.firstname} ${user.lastname}` : 'No Name'}
        className="app_header_dropdown"
        id="nav-dropdown">
        {/* <NavDropdown.Item eventKey="4.1">Settings</NavDropdown.Item> */}
        <NavDropdown.Divider />
        <NavDropdown.Item onClick={() => signOut()} eventKey="4.4">
          Logout
        </NavDropdown.Item>
      </NavDropdown>
    </div>
  );
};

export default Header;
